// src/templates/empanadaclub/MainMenu.jsx
// MainMenu personalizado para Empanada Club
// Sin Marketing, sin Feedback y Alertas, sin Métricas de Ofertas

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    FaChevronDown,
    FaUserPlus,
    FaBars,
    FaTimes,
    FaCoins,
    FaChartLine,
    FaEye,
    FaUsers,
    FaChartBar,
    FaFileAlt
} from 'react-icons/fa';
import CrearClienteForm from '../../components/modals/CrearClienteForm';
import SumarPuntosModal from '../../components/modals/SumarPuntosModal';
import QRScannerModal from '../../components/modals/QRScannerModal';

export default function MainMenu() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [showClienteForm, setShowClienteForm] = useState(false);
    const [showSumarPuntosModal, setShowSumarPuntosModal] = useState(false);
    const [showQRScanner, setShowQRScanner] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleCrearCliente = () => {
        setShowClienteForm(true);
    };

    const handleSumarPuntos = () => {
        setShowSumarPuntosModal(true);
    };

    const handleOpenQRScanner = () => {
        setShowQRScanner(true);
    };

    const closeClienteForm = () => {
        setShowClienteForm(false);
    };

    const closeSumarPuntosModal = () => {
        setShowSumarPuntosModal(false);
    };

    return (
        <nav className="bg-white shadow top-[64px] z-30">
            <div className="max-w-7xl mx-auto px-4">
                {/* Cabecera del menú (logo + hamburguesa) */}
                <div className="flex items-center justify-between py-2">
                    {/* Botón hamburguesa (sólo mobile) */}
                    <div className="flex md:hidden">
                        <button
                            onClick={toggleMenu}
                            type="button"
                            className="text-gray-600 hover:text-gray-800 focus:outline-none"
                        >
                            {menuOpen ? (
                                <FaTimes className="text-2xl" />
                            ) : (
                                <FaBars className="text-2xl" />
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/** 
       *  MENÚ DESKTOP: 
       *  Aparece en una barra inferior (border-t) con dropdowns por hover 
       */}
            <div className="hidden md:block border-t border-gray-200">
                <div className="max-w-7xl mx-auto px-4">
                    <ul className="flex items-center space-x-6 h-12">
                        {/* GESTION */}
                        <li className="relative group py-1">
                            <button className="flex items-center px-2 hover:text-gray-700 focus:outline-none">
                                Gestión <FaChevronDown className="ml-1 text-sm" />
                            </button>
                            <ul
                                className="absolute left-0 top-full mt-0 w-48 bg-white border border-gray-200 rounded shadow-lg 
                  opacity-0 group-hover:opacity-100 invisible group-hover:visible
                  transition-all duration-200 z-50"
                            >
                                <li>
                                    <Link
                                        to="/marcas-tiendas"
                                        className="block px-4 py-2 hover:bg-gray-100"
                                    >
                                        Gestión de Marcas y Tiendas
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/clientes"
                                        className="block px-4 py-2 hover:bg-gray-100"
                                    >
                                        Gestión de Clientes
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/inventario"
                                        className="block px-4 py-2 hover:bg-gray-100"
                                    >
                                        Gestión de Productos
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        {/* ANÁLISIS Y MÉTRICAS */}
                        <li className="relative group py-1">
                            <button className="flex items-center px-2 hover:text-gray-700 focus:outline-none">
                                <FaChartLine className="mr-1 text-green-500" />
                                Analytics <FaChevronDown className="ml-1 text-sm" />
                            </button>
                            <ul
                                className="absolute left-0 top-full mt-0 w-48 bg-white border border-gray-200 rounded shadow-lg 
                  opacity-0 group-hover:opacity-100 invisible group-hover:visible
                  transition-all duration-200 z-50"
                            >
                                <li>
                                    <Link
                                        to="/statistics/dashboard"
                                        className="flex items-center px-4 py-2 hover:bg-gray-100"
                                    >
                                        <FaEye className="mr-2 text-blue-500" />
                                        Dashboard Analytics
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/statistics/customer"
                                        className="flex items-center px-4 py-2 hover:bg-gray-100"
                                    >
                                        <FaUsers className="mr-2 text-green-500" />
                                        Estadísticas Clientes
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/statistics/store"
                                        className="flex items-center px-4 py-2 hover:bg-gray-100"
                                    >
                                        <FaChartBar className="mr-2 text-purple-500" />
                                        Estadísticas Tienda
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/statistics/reporting"
                                        className="flex items-center px-4 py-2 hover:bg-gray-100"
                                    >
                                        <FaFileAlt className="mr-2 text-indigo-500" />
                                        Centro de Reportes
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        {/* Botones de acción a la derecha */}
                        <li className="ml-auto flex items-center gap-2">
                            <button
                                onClick={handleCrearCliente}
                                className="flex items-center bg-blue-500 text-white px-3 py-2 rounded hover:bg-blue-600 transition-colors whitespace-nowrap"
                            >
                                <FaUserPlus className="mr-2" />
                                Crear Cliente
                            </button>
                            <button
                                onClick={handleSumarPuntos}
                                className="flex items-center bg-green-500 text-white px-3 py-2 rounded hover:bg-green-600 transition-colors whitespace-nowrap"
                            >
                                <FaCoins className="mr-2" />
                                Sumar Puntos
                            </button>
                        </li>
                    </ul>
                </div>
            </div >

            {/**
       * MENÚ MOBILE:
       * Se abre si "menuOpen" = true
       */}
            {
                menuOpen && (
                    <div className="md:hidden border-t border-gray-200">
                        <div className="px-4 pt-2 pb-4 bg-white shadow">
                            {/* Botón rápido Crear Cliente en mobile */}
                            <div className="mb-4">
                                <button
                                    onClick={() => {
                                        toggleMenu();
                                        handleCrearCliente();
                                    }}
                                    className="flex items-center bg-blue-500 text-white px-3 py-2 rounded hover:bg-blue-600 transition-colors  whitespace-nowrap"
                                >
                                    <FaUserPlus className="mr-2" />
                                    Crear Cliente
                                </button>
                            </div>
                            {/* Botón "Sumar Puntos" en mobile */}
                            <div className="mb-4">
                                <button
                                    onClick={() => {
                                        toggleMenu();
                                        handleSumarPuntos();
                                    }}
                                    className="flex items-center bg-green-500 text-white px-3 py-2 rounded hover:bg-green-600 transition-colors  whitespace-nowrap"
                                >
                                    <FaCoins className="mr-2" />
                                    Sumar Puntos
                                </button>
                            </div>

                            {/* Categorías en vertical */}
                            <ul className="space-y-2">
                                {/* Gestión */}
                                <li>
                                    <p className="font-semibold text-gray-800 mb-1">Gestión</p>
                                    <div className="ml-2 space-y-1">
                                        <Link
                                            to="/marcas-tiendas"
                                            onClick={toggleMenu}
                                            className="block px-2 py-1 hover:bg-gray-100 rounded"
                                        >
                                            Gestión de Marcas y Tiendas
                                        </Link>
                                        <Link
                                            to="/clientes"
                                            onClick={toggleMenu}
                                            className="block px-2 py-1 hover:bg-gray-100 rounded"
                                        >
                                            Gestión de Clientes
                                        </Link>
                                        <Link
                                            to="/inventario"
                                            onClick={toggleMenu}
                                            className="block px-2 py-1 hover:bg-gray-100 rounded"
                                        >
                                            Gestión de Productos
                                        </Link>
                                    </div>
                                </li>

                                {/* Analytics */}
                                <li>
                                    <p className="font-semibold text-gray-800 mb-1 flex items-center">
                                        <FaChartLine className="mr-2 text-green-500" />
                                        Analytics
                                    </p>
                                    <div className="ml-2 space-y-1">
                                        <Link
                                            to="/statistics/dashboard"
                                            onClick={toggleMenu}
                                            className="flex items-center px-2 py-1 hover:bg-gray-100 rounded"
                                        >
                                            <FaEye className="mr-2 text-blue-500" />
                                            Dashboard Analytics
                                        </Link>
                                        <Link
                                            to="/statistics/customer"
                                            onClick={toggleMenu}
                                            className="flex items-center px-2 py-1 hover:bg-gray-100 rounded"
                                        >
                                            <FaUsers className="mr-2 text-green-500" />
                                            Estadísticas Clientes
                                        </Link>
                                        <Link
                                            to="/statistics/store"
                                            onClick={toggleMenu}
                                            className="flex items-center px-2 py-1 hover:bg-gray-100 rounded"
                                        >
                                            <FaChartBar className="mr-2 text-purple-500" />
                                            Estadísticas Tienda
                                        </Link>

                                        <Link
                                            to="/statistics/reporting"
                                            onClick={toggleMenu}
                                            className="flex items-center px-2 py-1 hover:bg-gray-100 rounded"
                                        >
                                            <FaFileAlt className="mr-2 text-indigo-500" />
                                            Centro de Reportes
                                        </Link>
                                    </div>
                                </li>

                                {/* Notificaciones */}
                                <li>
                                    <p className="font-semibold text-gray-800 mb-1">Notificaciones</p>
                                    <div className="ml-2 space-y-1">
                                        <Link
                                            to="/notifications/settings"
                                            onClick={toggleMenu}
                                            className="block px-2 py-1 hover:bg-gray-100 rounded"
                                        >
                                            Configuración
                                        </Link>
                                        <Link
                                            to="/notifications/send"
                                            onClick={toggleMenu}
                                            className="block px-2 py-1 hover:bg-gray-100 rounded"
                                        >
                                            Enviar Notificaciones
                                        </Link>
                                        <Link
                                            to="/notifications/history"
                                            onClick={toggleMenu}
                                            className="block px-2 py-1 hover:bg-gray-100 rounded"
                                        >
                                            Historial
                                        </Link>
                                        <Link
                                            to="/notifications/templates"
                                            onClick={toggleMenu}
                                            className="block px-2 py-1 hover:bg-gray-100 rounded"
                                        >
                                            Templates
                                        </Link>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div >
                )
            }
            {/* Modal para crear cliente */}
            {
                showClienteForm && (
                    <CrearClienteForm
                        marcaId={null}
                        tiendas={[]}
                        onClose={closeClienteForm}
                        onClienteCreated={() => {
                            // Acción posterior a la creación
                        }}
                    />
                )
            }
            {
                showSumarPuntosModal && (
                    <SumarPuntosModal
                        onClose={() => setShowSumarPuntosModal(false)}
                    />
                )
            }
            {
                showQRScanner && (
                    <QRScannerModal
                        isOpen={showQRScanner}
                        onClose={() => setShowQRScanner(false)}
                    />
                )
            }
        </nav >
    );
}

